import { TON10Image, TON1Image, TON222Image, TON30Image, TON3Image, TON77Image } from '@app/assets';
import { MagicCookieItem } from '@app/shared/types/pages/cookiesShop';

export const MAGIC_COOKIES: MagicCookieItem[] = [
  { cookieAmount: 200, image: TON1Image, alt: '1TON', price: 1 },
  { cookieAmount: 625, image: TON3Image, alt: '3TON', price: 3, discount: 4 },
  { cookieAmount: 2100, image: TON10Image, alt: '10TON', price: 10, discount: 8 },
  { cookieAmount: 6780, image: TON30Image, alt: '30TON', price: 30, discount: 12 },
  { cookieAmount: 17700, image: TON77Image, alt: '77TON', price: 77, discount: 16 },
  { cookieAmount: 55000, image: TON222Image, alt: '222TON', price: 222, discount: 20 },
];
